define('CustomMyAccountData.SuiteScript2.Model',
  [
    'SCModel',
    'Utils'
  ],
  function (SCModelComponent, Utils) {
    'use strict';

    var SCModel = SCModelComponent.SCModel;

    function CustomMyAccountDataSuiteScript2Model() {
      SCModel.call(this);

      // Define properties of the model.
      this.urlRoot = function () {
        return Utils.getAbsoluteUrl(
          getExtensionAssetsPath('Modules/Main/SuiteScript2/SuiteScript2.Service.ss'),
          true
        );
      };
    }

    CustomMyAccountDataSuiteScript2Model.prototype = Object.create(SCModel.prototype);
    CustomMyAccountDataSuiteScript2Model.prototype.constructor = CustomMyAccountDataSuiteScript2Model;
    return CustomMyAccountDataSuiteScript2Model;
  }
);
